/** 列表/详情封面：每篇唯一；禁止第三方域名推广图、禁止多文共用同一张 */
const S = '/images/blog/screenshots'
const A = '/images/blog/covers/articles'

function svg(slug) {
	return `${A}/${slug}.svg`
}

/** 仅使用无水印的 GB 设置/功能界面截图，每文件最多对应一篇文章 */
export const BLOG_POST_PHOTO_COVERS = {
	'is-gb-whatsapp-safe': svg('is-gb-whatsapp-safe'),
	'will-gb-whatsapp-get-you-banned': `${S}/ban-account.webp`,
	'why-is-gb-whatsapp-account-banned': `${S}/GB-WhatsApp-temporary-ban-timer.webp`,
	'gb-whatsapp-says-use-official-whatsapp': `${S}/gb-whatsapp.webp`,
	'does-gb-whatsapp-anti-ban-work': svg('does-gb-whatsapp-anti-ban-work'),
	'gb-whatsapp-verification-code-not-received': `${S}/gbsettings-homescreen.webp`,
	'gb-whatsapp-keeps-crashing': svg('gb-whatsapp-keeps-crashing'),
	'gb-whatsapp-installation-error': `${S}/inatall-gbwhatsapp-steps.webp`,
	'gb-whatsapp-messages-not-sending': `${S}/send-media-file.webp`,
	'gb-whatsapp-status-download-not-working': svg('gb-whatsapp-status-download-not-working'),
	'gb-whatsapp-update-failed': svg('gb-whatsapp-update-failed'),
	'gb-whatsapp-expired-version': svg('gb-whatsapp-expired-version'),
	'gb-whatsapp-not-working-after-update': svg('gb-whatsapp-not-working-after-update'),
	'gb-whatsapp-android-compatibility': svg('gb-whatsapp-android-compatibility'),
	'gb-whatsapp-backup-not-working': svg('gb-whatsapp-backup-not-working'),
	'restore-gb-whatsapp-chats': svg('restore-gb-whatsapp-chats'),
	'switch-from-gb-whatsapp-to-official-whatsapp': svg('switch-from-gb-whatsapp-to-official-whatsapp'),
	'transfer-gb-whatsapp-to-new-phone': svg('transfer-gb-whatsapp-to-new-phone'),
	'schedule-messages-gb-whatsapp': `${S}/message-scheduler.webp`,
	'lock-individual-chats-gb-whatsapp': `${S}/gbwhatsapp-themes.webp`,
	'hide-blue-ticks-gb-whatsapp': `${S}/hide-blueticks.webp`,
	'use-gb-whatsapp-dnd-mode': `${S}/airplane-mode.webp`,
	'download-gb-whatsapp-status-videos': `${S}/anti-delete.webp`,
}

export const BLOG_LIST_DEFAULT_PHOTO = '/images/blog/covers/article-default.svg'
